import { type CentralIconName } from "@/types/central-icon";

export interface SearchableFilterOption {
  id: string;
  label: string;
  sublabel?: string;
  avatarUrl?: string | null;
}

export interface FilterFieldOption {
  value: string;
  label: string;
  badgeVariant?: string;
  badgeClassName?: string;
}

export interface FilterFieldDef {
  key: string;
  label: string;
  icon: CentralIconName;
  type?: "select" | "text" | "date_range" | "searchable" | "number";
  options: FilterFieldOption[];
  placeholder?: string;
  searchableOptions?: SearchableFilterOption[];
  /** Searchable picker layout. `member` shows avatars + optional sublabels; `label` is text-only with a fit-content dropdown. */
  searchablePresentation?: "member" | "label";
}

export type FilterOperator =
  | "is"
  | "is_not"
  | "contains"
  | "between"
  | "gt"
  | "gte"
  | "lt"
  | "lte";

export interface ActiveFilter {
  field: string;
  operator: FilterOperator;
  value: string;
}

export const FILTER_OPERATORS: { value: FilterOperator; label: string }[] = [
  { value: "is", label: "is" },
  { value: "is_not", label: "is not" },
];

export const NUMBER_FILTER_OPERATORS: {
  value: FilterOperator;
  label: string;
}[] = [
  { value: "is", label: "is" },
  { value: "gt", label: "is greater than" },
  { value: "gte", label: "is at least" },
  { value: "lt", label: "is less than" },
  { value: "lte", label: "is at most" },
];
